import React, { Component } from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import NavBar from 'components/Navigation';
import BackgroundVideo from 'components/Video';
import BackgroundImage from 'components/BackgroundImage';
import { updateVideo } from './Banner.actions';
import { bannerSelector } from './Banner.redux';
import s from './Banner.scss';// to import local scss fle

class Banner extends Component {

  static propTypes = {
    updateVideo: PropTypes.func.isRequired,
    data: PropTypes.shape(),
  };
  static defaultProps = {
    data: {},
  };
  constructor(props) {
    super(props);
    this.state = {
      showVideo: false,
    };

    this.toggleVideo = this.toggleVideo.bind(this);
  }
  toggleVideo() {
    this.setState({ showVideo: !this.state.showVideo });
    this.props.updateVideo();
  }
  render() {
    const { data } = this.props;
    let renderVideo = false;
    if (window.innerWidth > 700) {
      renderVideo = true;
    }
    const renderBackgroundVideo = renderIf(renderVideo);
    const renderNavbar = renderIf(!data.otherPages);
    const renderNavbarOnOtherPages = renderIf(data.otherPages);
    return (
      <div className={cn('row', s.bannerContainer)}>
        <div className={this.state.showVideo === true ? s.hidden : cn('col s12', s.bannerSection)}>
          <div className={cn('col s12', s.bannerHeader)}>
            {renderNavbar(
              <NavBar {...this.props} page="home" />,
            )}
            {renderNavbarOnOtherPages(
              <span>
                <Link to="/">
                  <img src="https://media.dev.myrecruitboard.com/Images/logo%402x.png" alt="logo" />
                </Link>
              </span>,
            )}
          </div>
          <div className={cn('col s12', s.bannerQuotes)}>
            <div className={s.centerDiv}>
              <div className={data.otherPages === true ? s.bigScreens : s.alignCenter}>
                <h1>FOOTBALL RECRUITING<br />DOWN TO A SCIENCE</h1>
                <span className={s.bannerDesc}>{data.bannerDesc}
                </span><br /><br />
                <Link to="/about">
                  <button
                    className={data.otherPages === true ?
                                s.whiteLearnMore : s.learnMore}
                  >
                          LEARN MORE
                        </button>
                </Link>
                <button
                  className={data.otherPages === true ? s.hidden : s.playvideo}
                  onClick={this.toggleVideo}
                > WATCH OUR FILM
                      </button>
              </div>
            </div>
          </div>
        </div>
        <div className={data.fullsize === true ? s.fullbanner : s.halfBanner}>
          {data.fullsize === true ?
            <div>
              {renderBackgroundVideo(
                <BackgroundVideo />,
              )}
            </div>
                      :
            <BackgroundImage
              props={data.backgroundUrl}
              otherPages={data.otherPages}
            />
                  }
        </div>
      </div>
    );
  }
}

export default connect(bannerSelector, {
  updateVideo,
})(Banner);



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.js